<template>
  <footer class="app-footer">
    <div class="app-footer__left">
      <div class="app-footer__left-content">
        <h2 class="app-footer__left-content__title">
          Quick and Easy Financing
        </h2>
        <div class="app-footer__left-content__text" hidden>
          Quick and Easy Financing
        </div>
        <a
          href="https://myascentium.com/ApplyNow/CommCredit?v=988727b9-4f20-48af-9675-832bb6f37507&s=f981a6da-ef4e-4c51-967b-834d6b2e7650"
          target="_blank"
        >
          <button class="app-footer__left-content__btn">
            Get Financing
          </button>
        </a>
      </div>
    </div>
    <div class="app-footer__right">
      <div class="app-footer__right-top">
        <img src="/img/logo.png" alt />
      </div>
      <div class="app-footer__right-middle">
        <h3 class="app-footer__right-middle__title">Contacts</h3>
        <ul class="app-footer__right-middle__list">
          <li class="app-footer__right-middle__list-item">9277 187th Ave NW</li>
          <li class="app-footer__right-middle__list-item">Nowthen, MN 55330</li>
          <br />
          <li class="app-footer__right-middle__list-item">
            <b>Phone:&nbsp;</b>
            <a href="tel:6124707008">(612) 470 -7008</a>
          </li>
          <li class="app-footer__right-middle__list-item"><b>Fax:&nbsp;</b>(612) 746-7622</li>
          <li class="app-footer__right-middle__list-item">
            <b>Email:&nbsp;</b>
            <a href="mailto:info@foodtrailersandtrucks.com">info@foodtrailersandtrucks.com</a>
          </li>
        </ul>
        <button @click="estimateNowClick" class="app-footer__right-middle__btn">
          get an estimate
        </button>
      </div>
      <div class="app-footer__right-bottom">
        <div class="app-footer__right-bottom__menu">
          <router-link
            v-for="(link, i) in nav"
            :to="{ name: link.link }"
            v-bind:key="i"
            class="app-footer__right-bottom__menu-item"
            >{{ link.title }}</router-link
          >
        </div>
        <div class="app-footer__right-bottom__copyright">
          Copyright by FoodTrailersAndTrucks.com | All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import HeaderNav from './helpers/headerNav'

export default {
  name: 'MainFooter',
  data: () => ({
    nav: HeaderNav.NAVIGATION
  }),
  methods: {
    estimateNowClick() {
      if (this.$route.path !== '/quote') {
        this.$router.push({ path: 'quote' })
      } else {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
